var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15405_42727",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15405_42727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 29.3385C15.4223 29.3385 14.9 29.1997 14.4334 28.9219C13.9667 28.6441 13.6 28.2719 13.3334 27.8052C12.6 27.8052 11.9723 27.5441 11.45 27.0219C10.9278 26.4997 10.6667 25.8719 10.6667 25.1385V20.4052C9.3556 19.5385 8.3056 18.3941 7.51671 16.9719C6.72782 15.5497 6.33337 14.0052 6.33337 12.3385C6.33337 9.64965 7.27226 7.36632 9.15004 5.48854C11.0278 3.61076 13.3112 2.67188 16 2.67188C18.6889 2.67188 20.9723 3.61076 22.85 5.48854C24.7278 7.36632 25.6667 9.64965 25.6667 12.3385C25.6667 14.0497 25.2723 15.6052 24.4834 17.0052C23.6945 18.4052 22.6445 19.5385 21.3334 20.4052V25.1385C21.3334 25.8719 21.0723 26.4997 20.55 27.0219C20.0278 27.5441 19.4 27.8052 18.6667 27.8052C18.4 28.2719 18.0334 28.6441 17.5667 28.9219C17.1 29.1997 16.5778 29.3385 16 29.3385ZM13.3334 25.1385H18.6667V23.9385H13.3334V25.1385ZM13.3334 22.6052H18.6667V21.3385H13.3334V22.6052ZM17 18.6719V15.0719L19.2334 12.8385C19.4334 12.6385 19.5334 12.4052 19.5334 12.1385C19.5334 11.8719 19.4334 11.6385 19.2334 11.4385C19.0334 11.2385 18.8 11.1385 18.5334 11.1385C18.2667 11.1385 18.0334 11.2385 17.8334 11.4385L16 13.2719L14.1667 11.4385C13.9667 11.2385 13.7334 11.1385 13.4667 11.1385C13.2 11.1385 12.9667 11.2385 12.7667 11.4385C12.5667 11.6385 12.4667 11.8719 12.4667 12.1385C12.4667 12.4052 12.5667 12.6385 12.7667 12.8385L15 15.0719V18.6719H17Z",
    fill: "#D99E16"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlub);
export default __webpack_public_path__ + "static/media/blub.9e34988f3b721fbd5b450cede5c160c4.svg";
export { ForwardRef as ReactComponent };